import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { MenuComponent } from './components/menu/menu.component';
import { UpdateService } from './services/update.service';
import { UpdateModalComponent } from './components/update-modal/update-modal.component';
import { NgIf } from '@angular/common';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MenuComponent, UpdateModalComponent, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'beheer-dwt';
  showUpdateModal = false;

  constructor(
    public auth: Auth,
    private router: Router,
    public authService: AuthService,
    private updateService: UpdateService,
    private swUpdate: SwUpdate
  ) {}

  ngOnInit(): void {
    // Initialize update service
    this.updateService.initialize();

    // Check for updates on load
    if (this.swUpdate.isEnabled) {
      // Listen for version ready events
      this.swUpdate.versionUpdates
        .pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
        )
        .subscribe(() => {
          this.showUpdateModal = true;
        });

      // Check for updates immediately
      this.swUpdate.checkForUpdate().then(() => {
        console.log('Checking for updates on app load...');
      }).catch(err => {
        console.error('Error checking for updates:', err);
      });
    }
  }

  onRefresh(): void {
    this.updateService.activateUpdate();
  }

  onLater(): void {
    this.showUpdateModal = false;
  }
}
